import { useAddAlert } from '@/hooks/useAddAlert'
import { selectProfile } from '@store/profile.reducer'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import classes from './index.module.css'
import { useEffect, useState } from 'react'
import { EditIcoNewDesign, IconDone, IcoRemove } from '@/utils/icons'
import Preloader from '@UI/Preloader'
import {
  API,
  classApi,
  departments,
  directionOrdersApi,
  massActionsApi,
  usersAPI,
} from '@/api'
import { getAvatar } from '@/helpers/getAvatar'
import Button from '@UI/Button'
import Modal, { ModalContainer } from '@common/Modal'
import { BodyModal } from '@common/ProfileCard/BodyModal/BodyModal'
import { Tabs } from 'antd'
import { AuthService } from '@/services/AuthService'
import ModalRecoverPassword from '../../Colleges/modals/ModalRecoverPassword'
import setSettingsFromServer from '@/helpers/setSettingsFromServer'
import ActionModal from '../ActionModal'
import UserSearch from '../../components/UserSearch'
import UserBlock from '../../components/UserBlock'
import roleActive from '@/helpers/roleActive'
import SelectDepartmentModal from '../SelectDepartmentModal'
import EmailVerifyWrapper from '@common/EmailVerifyWrapper/EmailVerifyWrapper'

const EditParentModal = ({
  parentId = null,
  onDismiss = () => {},
  onUpdate = () => {},
  onClickByChildren = () => {},
}) => {
  return (
    <div className={classes.modalContainer}>
      <ParentProfileContainer
        parentId={parentId}
        onDismiss={onDismiss}
        onUpdate={onUpdate}
        onClickByChildren={onClickByChildren}
      />
    </div>
  )
}

const ParentProfileContainer = ({
  parentId = null,
  onDismiss = () => {},
  onUpdate = () => {},
  onClickByChildren = () => {},
  className = '',
}) => {
  const addAlert = useAddAlert()
  const [isLoading, setIsLoading] = useState(false)
  const [user, setUser] = useState({})
  const [userOld, setUserOld] = useState({})
  const [bodyModal, setBodyModal] = useState(null)
  const [actionModal, setActionModal] = useState(null)
  const [recoverPasswordModal, setRecoverPasswordModal] = useState(false)

  const constDataModal = {
    state: user,
    setState: setUser,
    close: () => setBodyModal(null),
    setModal: (type) => setBodyModal({ type }),
    addAlert,
  }

  const params = [
    'name',
    'email',
    'phone',
    'sex',
    'birth_date',
    'city',
    'address',
    'education',
    'experience',
    'custom_id',
    'link_to_vk',
    'password',
    'about',
    'notes',
    'about_student',
    'parent_name',
    'parent_phone',
    'parent_telegram',
    'parent_email',
    'parent_whatsapp',
    'roles',
    'learning_class',
    'timezone',
    'url_conference',
    'seminarianDirection',
    'update_vks',
    'children',
    'about_parent',
  ]

  const save = async () => {
    setIsLoading(true)
    const data = () => {
      const newData = {}

      for (let key in user) {
        if (params.includes(key)) {
          if (typeof user[key] === 'string') {
            if (user[key]?.length === 0) newData[key] = null
            else newData[key] = user[key]
          } else {
            newData[key] = user[key]
          }
          if ([key] == 'custom_id' && userOld[key] && !user[key])
            newData[key] = null
          if ([key] == 'children')
            newData[key] = user[key]?.map((child) => child.id)
        }
      }
      return newData
    }

    usersAPI
      .upd({ id: user.id, data: data() })
      .then((res) => {
        if (res.data.status === 'success') {
          addAlert({ title: 'Профиль изменен' })
          onUpdate()
        } else {
          addAlert({
            type: 'error',
            title:
              'Упс! Ошибка. Попробуйте ещё раз или обратитесь к администратору',
          })
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const getUser = (withLoader = true) => {
    setIsLoading(withLoader)
    usersAPI
      .getUser({
        id: parentId,
        expand: [
          'userProfile',
          'children',
          'roles',
          'contracts',
          'orgUnits.head',
        ],
      })
      .then((res) => {
        const data = {}
        if (res.data?.id !== undefined)
          for (let key in res.data) {
            if (key === 'userProfile')
              for (let y in res.data.userProfile)
                data[y] = res.data.userProfile[y]
            else data[key] = res.data[key]
          }
        setUser(data)
        setUserOld(data)
        setIsLoading(false)
      })
  }

  useEffect(() => {
    getUser()
  }, [])

  const authorization = () => {
    usersAPI.authorization(user.id).then((response) => {
      AuthService.auth(response.data.user, response.data.token)
      window.location.href = '/'
    })
  }

  const changeUserStatus = (status, alert) => {
    // const courses = childrenDirection?.filter(({class_id}) => !class_id) ?? []

    // if(courses?.length > 0){
    //   addAlert({ title: "Нельзя удалить учащегося с активными курсами!", type: 'error' });
    //   return
    // }

    const data = new FormData()
    data.append('ids', JSON.stringify([user.id]))
    data.append('status', status)

    const handleResponse = (res) => {
      if (res.data.status !== 'success') {
        addAlert({
          title: 'Ошибка',
          text: 'Упс! Ошибка. Попробуйте ещё раз или обратитесь к администратору',
          type: 'error',
        })
      } else {
        addAlert({ title: alert })
        setUser((prevProfile) => ({
          ...prevProfile,
          status: status,
        }))
        onUpdate()
      }
    }

    const handleError = (error) => {
      addAlert({
        title: 'Ошибка',
        text: 'Что-то пошло не так. Пожалуйста, попробуйте ещё раз.',
        type: 'error',
      })
    }

    massActionsApi
      .changeStatus(data)
      .then((res) => handleResponse(res))
      .catch(handleError)
  }

  const handleFooterAction = (action) => {
    switch (action) {
      case 'save':
        save()
        break
      case 'cancel':
        onDismiss()
        break
      case 'resetPassword':
        setRecoverPasswordModal(true)
        break
      case 'changePassword':
        setBodyModal({ type: 'ChangePassword' })
        break
      case 'authorize':
        authorization()
        break
      case 'block':
        setActionModal({
          title: 'Подтвердите действие',
          content: `Вы уверены что хотите заблокировать ${
            user?.name ?? 'родителя'
          }?`,
          onConfirm: () =>
            changeUserStatus(
              user?.status === 0 ? 10 : 0,
              user?.status === 0
                ? 'Родитель восстановлен'
                : 'Родитель заблокирован',
            ),
          onDismiss: () => setActionModal(null),
        })
        break
      case 'delete':
        setActionModal({
          title: 'Подтвердите действие',
          content: `Вы уверены что хотите удалить ${user?.name ?? 'родителя'}?`,
          onConfirm: () =>
            changeUserStatus(
              user?.status === 9 ? 10 : 9,
              user?.status === 9 ? 'Родитель восстановлен' : 'Родитель удален',
            ),
          onDismiss: () => setActionModal(null),
        })
        break
      default:
        console.log('Unknown action')
    }
  }

  if (isLoading) {
    return (
      <div className={classes.preloaderContainer}>
        <Preloader fullScreen="center" />
      </div>
    )
  }

  return (
    <>
      <div
        className={classNames(classes.parentContentWrapper, {
          [className]: !!className,
        })}
      >
        <ParentProfileHeader
          parent={user}
          setUser={setUser}
          setModal={setBodyModal}
        />
        <ParentProfileBody
          parent={{ ...user }}
          setUser={setUser}
          setModal={setBodyModal}
          getUser={getUser}
          onClickByChildren={onClickByChildren}
        />
        <ParentProfileFooter parent={user} onAction={handleFooterAction} />
      </div>
      <Modal
        active={bodyModal != null}
        className={classes.modalWrapperOld}
        setActive={() => setBodyModal(null)}
        classNameBackground={classes.modalBackground}
      >
        <BodyModal {...bodyModal} {...constDataModal} />
      </Modal>
      <Modal
        active={recoverPasswordModal}
        setActive={() => setRecoverPasswordModal(false)}
      >
        {recoverPasswordModal && (
          <ModalContainer closeModal={() => setRecoverPasswordModal(false)}>
            <ModalRecoverPassword
              setActive={() => setRecoverPasswordModal(false)}
              userId={user.id}
            />
          </ModalContainer>
        )}
      </Modal>
      <Modal
        active={actionModal !== null}
        setActive={() => setActionModal(null)}
        className={classes.modalWrapper}
      >
        <ActionModal
          title={actionModal?.title}
          content={actionModal?.content}
          onDismiss={actionModal?.onDismiss}
          onAction={actionModal?.onConfirm}
        />
      </Modal>
    </>
  )
}

const ParentProfileBody = ({
  parent = {},
  setUser = () => {},
  setModal = () => {},
  getUser = () => {},
  onClickByChildren = () => {},
}) => {
  const tabItems = [
    {
      label: 'О родителе',
      key: 'profile',
      children: (
        <ParentProfileContent
          parent={parent}
          setUser={setUser}
          setModal={setModal}
          getUser={getUser}
          onClickByChildren={onClickByChildren}
        />
      ),
    },
  ]

  return (
    <div className={classes.bodyContainer}>
      <Tabs
        className={classes.tabsContainer}
        defaultActiveKey="profile"
        items={tabItems}
      />
    </div>
  )
}

const ParentProfileContent = ({
  parent = {},
  setUser = () => {},
  setModal = () => {},
  getUser = () => {},
  onClickByChildren = () => {},
}) => {
  const requireParentEmailConfirmation = useSelector(store => store.settings.requireParentEmailConfirmation === '1');

  const profile = useSelector(selectProfile)
  const handleChange = (event, field) => {
    const value = event.target.value
    setUser((prevProfile) => ({
      ...prevProfile,
      [field]: value,
    }))
  }

  const [childrenModal, setChildrenModal] = useState(false)
  const children = Array.isArray(parent.children) ? parent.children : []

  const setChildren = (children) => {
    setUser((prevProfile) => ({
      ...prevProfile,
      children,
    }))
  }
  const deleteChild = (id) => {
    setChildren(children.filter((child) => child.id !== id))
  }
  const { adminActive } = roleActive()
  const isAdmin = adminActive()

  return (
    <div className={classes.bodyContent}>
      <div className={classes.flexContainerMainInfo}>
        <input
          className={classes.inputSmallContainer}
          value={parent?.phone ?? ''}
          onChange={(e) => handleChange(e, 'phone')}
          placeholder="Телефон"
        />
        <EmailVerifyWrapper
          visible={requireParentEmailConfirmation}
          verified={parent?.is_email_confirmed === 1}
          style={{ width: 'auto' }}
        >
          <input
            className={classes.inputSmallContainer}
            value={parent?.email ?? ''}
            onChange={(e) => handleChange(e, 'email')}
            placeholder="Почта"
          />
        </EmailVerifyWrapper>
        <input
          className={classNames(
            classes.inputSmallContainer,
            classes.link_to_vk,
          )}
          value={parent?.link_to_vk ?? ''}
          onChange={(e) => handleChange(e, 'link_to_vk')}
          placeholder="Ссылка на соц.сети"
        />
        <div className={classes.inputSmallContainer}>{`ID: ${parent?.id}`}</div>
      </div>
      {profile.role !== 'parent' && profile.role !== 'children' && (
        <div className={classes.containerAboutParentInfo}>
          <ContainerWithHeader title="О родителе:">
            <textarea
              className={classes.inputTextAreaContainer}
              rows="3"
              value={parent?.about_parent ?? ''}
              onChange={(e) => handleChange(e, 'about_parent')}
              placeholder="Информация о родителе, которую он не видит"
            />
          </ContainerWithHeader>
        </div>
      )}

      <ContainerWithHeader title="Дети:">
        {children.map((user) => (
          <UserBlock
            user={user}
            deleteUser={
              isAdmin
                ? (childrenId) =>
                    setModal({
                      type: 'RemoveChildren',
                      data: { deleteChild, childrenId },
                    })
                : false
            }
            onClickByUser={onClickByChildren}
          />
        ))}
        {isAdmin && (
          <Button
            newDesign
            className={classNames(
              classes.secondaryButton,
              classes.truncateText,
              classes.textSemiBold,
            )}
            onClick={() => setChildrenModal(true)}
            style={{ width: 'fit-content' }}
          >
            Привязать ребенка
          </Button>
        )}
        <Modal
          active={childrenModal}
          className={classes.modalWrapperOld}
          setActive={() => setChildrenModal(false)}
          classNameBackground={classes.modalBackground}
        >
          <ModalContainer closeModal={() => setChildrenModal(false)}>
            <UserSearch
              selectUsers={children}
              setSelectUser={setChildren}
              closeModal={() => setChildrenModal(false)}
              roleSeach="children"
            />
          </ModalContainer>
        </Modal>
      </ContainerWithHeader>
      <ContainerWithHeader title="Отделы:">
        <ParentDepartmentList
          parent={parent}
          onAddDepartment={() => {
            getUser(false)
          }}
          onRemoveDepartment={() => {
            getUser(false)
          }}
          isAdmin={isAdmin}
        />
      </ContainerWithHeader>
      <ContainerWithHeader title="Договора:">
        <ParentDocksList
          parent={parent}
          onAddDock={isAdmin ? () => setModal({ type: 'AddContract' }) : false}
          onDeleteDock={(dock) =>
            setModal({ type: 'RemoveContract', data: dock?.id })
          }
          isAdmin={isAdmin}
        />
      </ContainerWithHeader>
    </div>
  )
}

const ParentDocksList = ({
  parent = {},
  onAddDock = () => {},
  onDeleteDock = () => {},
  isAdmin = false,
}) => {
  const [viewAll, setViewAll] = useState(false)

  const contractsToShow = viewAll
    ? parent?.contracts
    : parent?.contracts?.slice(0, 3)

  return (
    <div className={classes.containerParentDocks}>
      <div className={classes.containerParentDocksList}>
        <div className={classes.docksListItemContainer}>
          <div className={classes.docksListHeader}>
            <div className={classes.textSemiBold}>Название договора</div>
            <div
              style={{ textAlign: 'center' }}
              className={classes.textSemiBold}
            >
              Файл
            </div>
          </div>
          {onAddDock && (
            <Button
              newDesign
              className={classNames(
                classes.secondaryButton,
                classes.truncateText,
                classes.textSemiBold,
              )}
              onClick={onAddDock}
            >
              Добавить договор
            </Button>
          )}
        </div>
        {contractsToShow?.map((dock, index) => {
          return (
            <div className={classes.docksListItemContainer} key={index}>
              <div className={classes.docksListItem}>
                <div>{dock.name}</div>
                <a
                  className={classNames(
                    classes.secondaryButton,
                    classes.truncateText,
                    classes.fillMinWidth,
                  )}
                  style={{ justifyContent: 'center' }}
                  href={process.env.REACT_APP_PATH_FILE + dock.file_path}
                  target="_blank"
                  rel="noreferrer"
                >
                  Файл загружен
                </a>
              </div>
              {isAdmin && (
                <div className={classes.deleteDockButtonWrapper}>
                  <div
                    className={classes.deleteDockButton}
                    onClick={() => onDeleteDock(dock)}
                  >
                    <IcoRemove />
                  </div>
                </div>
              )}
            </div>
          )
        })}
      </div>
      {parent?.contracts?.length > 3 && (
        <Button
          newDesign
          className={classNames(classes.secondaryButton, classes.truncateText)}
          onClick={() => setViewAll(!viewAll)}
        >
          {viewAll ? 'скрыть' : 'смотреть еще'}
        </Button>
      )}
    </div>
  )
}

const ContainerWithHeader = ({ title, children }) => {
  return (
    <div className={classes.containerWithHeader}>
      <div className={classes.containerWithHeaderTitle}>{title}</div>
      {children}
    </div>
  )
}

const ParentProfileHeader = ({
  //platformSettings = {},
  parent = {},
  //setUser = () => {},
  setModal = () => {},
}) => {
  return (
    <>
      <div className={classes.headerContainer}>
        <div className={classes.userAvatarContainer}>
          <img
            className={classes.userAvatar}
            src={getAvatar(parent)}
            alt={parent?.name}
          />
          <div className={classes.userAvatarEditIconWrapper}>
            <EditIcoNewDesign
              className={classes.userAvatarEditIcon}
              onClick={() => setModal({ type: 'Ava' })}
            />
          </div>
        </div>
        <div className={classes.userHeaderInfoContainer}>
          <div className={classes.userHeaderNameContainer}>
            <span className={classes.truncateText}>{parent?.name}</span>
            <EditIcoNewDesign
              className={classes.editIcon}
              onClick={() => setModal({ type: 'Name' })}
            />
          </div>
          <div className={classes.subheaderContainer}>
            <div className={classes.userHeaderLastActiveContainer}>
              <div className={classes.userHeaderLastActiveDot} />
              <span className={classes.truncateText}>
                {formatLastActionTime(parent?.last_login)}
              </span>
            </div>
          </div>
        </div>
        <div className={classes.userHeaderRightContainer}>
          <div className={classes.inputSmallContainer}>
            <span className={classes.truncateText}>
              {`Дата регистрации: ${formatTimestampDate(parent?.created_at)}`}
            </span>
          </div>
        </div>
      </div>
    </>
  )
}

function formatTimestampDate(timestamp) {
  const date = new Date(timestamp * 1000)

  const formattedDate = date.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })

  return `${formattedDate}`
}

function formatLastActionTime(time) {
  if (!time) {
    return 'нет активности'
  }

  const date = new Date(time)

  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')

  return `${day}.${month}.${year}, ${hours}:${minutes}`
}

const ParentProfileFooter = ({ parent, onAction }) => {
  const [settings, setSettings] = useState({})
  useEffect(() => {
    setSettingsFromServer(setSettings)
  }, [])
  const userIdsAllowedToDeleteParents = settings.userIdsAllowedToDeleteParents
    ? JSON.parse(settings.userIdsAllowedToDeleteParents)
    : []
  const selectEmployeesWhoAreAllowedDeleteParents =
    settings.selectEmployeesWhoAreAllowedDeleteParents === '1'

  const profile = useSelector(selectProfile)

  const actionsAdmin = [
    { label: 'Сохранить', action: 'save' },
    { label: 'Отмена', action: 'cancel' },
    { label: 'Сбросить пароль', action: 'resetPassword' },
    { label: 'Авторизоваться', action: 'authorize' },
    ...(userIdsAllowedToDeleteParents.includes(profile.id) ||
    !selectEmployeesWhoAreAllowedDeleteParents
      ? [
          {
            label: parent?.status === 0 ? 'Разблокировать' : 'Заблокировать',
            action: 'block',
          },
        ]
      : []),
    ...(userIdsAllowedToDeleteParents.includes(profile.id) ||
    !selectEmployeesWhoAreAllowedDeleteParents
      ? [
          {
            label: parent?.status === 9 ? 'Восстановить' : 'Удалить',
            action: 'delete',
          },
        ]
      : []),
  ]
  const actionsParent = [
    { label: 'Сохранить', action: 'save' },
    { label: 'Восстановить пароль', action: 'changePassword' },
  ]
  const { adminActive } = roleActive()
  const isAdmin = adminActive()
  const actions = isAdmin ? actionsAdmin : actionsParent

  return (
    <div className={classes.footerContainer}>
      {actions.map(({ label, action }) => (
        <Button
          key={action}
          newDesign
          className={classNames(classes.footerButton, classes.truncateText)}
          onClick={() => onAction(action)}
        >
          {label}
        </Button>
      ))}
    </div>
  )
}

const ParentDepartmentList = ({
  parent = {},
  onAddDepartment = () => {},
  onRemoveDepartment = () => {},
  isAdmin = false,
}) => {
  const addAlert = useAddAlert()
  const [modal, setModal] = useState(null)

  const errorShow = () => {
    addAlert({
      title: 'Ошибка',
      text: 'Что-то пошло не так. Пожалуйста, попробуйте ещё раз.',
      type: 'error',
    })
  }

  const removeFromDepartment = (id) => {
    const departmentName =
      parent?.orgUnits?.find((item) => item?.id === modal?.id)?.name ?? '-'

    departments
      .deleteEmployee({
        userId: parent?.id,
        unitId: id,
      })
      .then((res) => {
        if (res.data === true) {
          addAlert({
            text: `${parent?.name} исключен из отдела ${departmentName}!`,
          })
          onRemoveDepartment()
        } else {
          errorShow()
        }
      })
  }

  const addToDepartment = (department) => {
    departments
      .addAnEmployeeToDepartment({
        userId: [parent?.id],
        unitId: department?.id,
      })
      .then((res) => {
        if (res.data) {
          onAddDepartment()
          addAlert({
            text: `${parent?.name} добавлен в отдел ${department?.name}!`,
          })
        } else {
          errorShow()
        }
      })
  }

  return (
    <>
      <div className={classes.parentsDepartmentsWrapper}>
        <div className={classes.parentsDepartmentsRow}>
          <div className={classes.parentsDepartmentsHeaderCell}>Отдел</div>
          <div className={classes.parentsDepartmentsHeaderCell}>
            Руководитель
          </div>
          <div
            className={classNames(
              classes.parentsDepartmentsHeaderCell,
              classes.parentsDepartmentsHeaderCellAction,
            )}
          >
            {isAdmin && (
              <Button
                newDesign
                className={classNames(
                  classes.secondaryButton,
                  classes.truncateText,
                  classes.textSemiBold,
                )}
                action={() => {
                  setModal({ type: 'add-department' })
                }}
              >
                Добавить отдел
              </Button>
            )}
          </div>
        </div>
        {!parent?.orgUnits && (
          <div className={classes.departmentsRowStub}>Отделов нет</div>
        )}
        {parent?.orgUnits?.map((item, index) => {
          return (
            <div key={index} className={classes.parentsDepartmentsRow}>
              <div className={classes.parentsDepartmentsCell}>
                {item?.name ?? '-'}
              </div>
              <div className={classes.parentsDepartmentsCell}>
                {item?.head?.name ?? '-'}
              </div>
              <div
                className={classNames(
                  classes.parentsDepartmentsCell,
                  classes.parentsDepartmentsHeaderCellAction,
                )}
              >
                {isAdmin && (
                  <Button
                    newDesign
                    className={classNames(
                      classes.ternaryButton,
                      classes.truncateText,
                      classes.textSemiBold,
                    )}
                    action={() => {
                      setModal({ type: 'remove-department', id: item?.id })
                    }}
                  >
                    Исключить
                  </Button>
                )}
              </div>
            </div>
          )
        })}
      </div>
      <Modal
        active={modal !== null}
        setActive={() => setModal(null)}
        className={classes.modalWrapper}
      >
        {modal?.type === 'remove-department' && (
          <ActionModal
            title={'Исключить из отдела'}
            content={`Вы уверены что хотите исключить ${
              parent?.name
            } из отдела ${
              parent?.orgUnits?.find((item) => item?.id === modal?.id).name
            }?`}
            onDismiss={() => setModal(null)}
            onAction={() => {
              removeFromDepartment(modal?.id)
              setModal(null)
            }}
          />
        )}
        {modal?.type === 'add-department' && (
          <SelectDepartmentModal
            title={'Добавить к отделу'}
            onDismiss={() => setModal(null)}
            onSelect={(department) => {
              if (department === null) {
                addAlert({
                  title: 'Нужно выбрать отдел для продолжения!',
                })
                return
              }
              addToDepartment(department)
              setModal(null)
            }}
          />
        )}
      </Modal>
    </>
  )
}

const toBoolean = (value) => {
  return value === '1' || value === true
}

export default EditParentModal

export { ParentProfileContainer }
